/**
 * 부팅/이동 중 표시 — 원본 `app.css` 의 `.boot`.
 *
 * 점멸 키프레임(`plt-pulse`)은 `src/styles/index.css` 에 있고, 모션 민감 사용자에게는 같은 파일의
 * `prefers-reduced-motion` 블록이 애니메이션을 끕니다(문구만으로도 읽힙니다).
 */
export function Boot({ text }: { text: string }) {
  return (
    <div
      role="status"
      className="flex min-h-[60vh] items-center justify-center gap-[10px] font-semibold text-grey-500"
    >
      <span className="h-[10px] w-[10px] rounded-full bg-blue-500 animate-[plt-pulse_1.1s_ease-in-out_infinite]" />
      <span>{text}</span>
    </div>
  );
}
